/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ImageModel } from './ImageModel';
import {
    ImageModelFromJSON,
    ImageModelFromJSONTyped,
    ImageModelToJSON,
} from './ImageModel';

/**
 * ニュースの内容
 * @export
 * @interface NewsContentModel
 */
export interface NewsContentModel {
    /**
     * ニュースID
     * @type {string}
     * @memberof NewsContentModel
     */
    id: string;
    /**
     * ニュースのタイトル
     * @type {string}
     * @memberof NewsContentModel
     */
    title: string;
    /**
     * 0 の場合、html。1の場合、json
     * @type {number}
     * @memberof NewsContentModel
     */
    descriptionType?: number;
    /**
     * ニュース本文
     * @type {string}
     * @memberof NewsContentModel
     */
    body?: string;
    /**
     * ニュースの発行日のUNIX時間
     * @type {number}
     * @memberof NewsContentModel
     */
    datePublished: number;
    /**
     * 
     * @type {ImageModel}
     * @memberof NewsContentModel
     */
    visualImage?: ImageModel;
    /**
     * ニュースのカテゴリー
     * @type {Array<string>}
     * @memberof NewsContentModel
     */
    category?: Array<string>;
    /**
     * 管理者モードフラグ
     * @type {boolean}
     * @memberof NewsContentModel
     */
    isAdminMode?: boolean;
}

/**
 * Check if a given object implements the NewsContentModel interface.
 */
export function instanceOfNewsContentModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "datePublished" in value;

    return isInstance;
}

export function NewsContentModelFromJSON(json: any): NewsContentModel {
    return NewsContentModelFromJSONTyped(json, false);
}

export function NewsContentModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewsContentModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'descriptionType': !exists(json, 'descriptionType') ? undefined : json['descriptionType'],
        'body': !exists(json, 'body') ? undefined : json['body'],
        'datePublished': json['datePublished'],
        'visualImage': !exists(json, 'visualImage') ? undefined : ImageModelFromJSON(json['visualImage']),
        'category': !exists(json, 'category') ? undefined : json['category'],
        'isAdminMode': !exists(json, 'isAdminMode') ? undefined : json['isAdminMode'],
    };
}

export function NewsContentModelToJSON(value?: NewsContentModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'descriptionType': value.descriptionType,
        'body': value.body,
        'datePublished': value.datePublished,
        'visualImage': ImageModelToJSON(value.visualImage),
        'category': value.category,
        'isAdminMode': value.isAdminMode,
    };
}

